import { usePostStandardUrineApi, usePutStandardUrineApi } from 'api/standard_urine'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { StandardUrine, StandardUrineForm } from 'entities/standard_urine'
import { Flex } from 'components/shared/flex'
import { DateField, InputField } from 'components/shared/input'

type UserFormViewProps = {
    form: Form<StandardUrineForm>
    apiError: ApiError
    isEdit?: boolean
}

export const StandardUrineFormView = ({ form, apiError, isEdit }: UserFormViewProps) => {
    return (
        <>
            <Flex flexDirection='column'>
                <Flex>
                    <InputField form={form} attr="lot" label='lot' />
                    <DateField form={form} attr="date" label='date' />
                </Flex>
                <InputField form={form} attr="note" label='note' />
            </Flex>
        </>
    )
}

type NewStandardUrineFormProps = {
    onComplete?: () => void
}

export const NewStandardUrineForm = (props: NewStandardUrineFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostStandardUrineApi()
    const form = useForm<StandardUrineForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>がん検査の登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StandardUrineFormView form={form} apiError={api.apiError} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditStandardUrineFormProps = {
    StandardUrine: StandardUrine
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditStandardUrineForm = (props: EditStandardUrineFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutStandardUrineApi()
    const form = useForm<StandardUrineForm>(props.StandardUrine)

    useEffectSkipFirst(() => {
        form.set(props.StandardUrine)
    }, [props.StandardUrine])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>がん検査の編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <StandardUrineFormView form={form} apiError={api.apiError} isEdit />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
